import { Component, OnInit } from "@angular/core";
import {
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from "@angular/router";

import { IconService } from "./core/services/icon.service";
import { LoaderService } from "./core/services/loader.service";
import { WindowRef } from "./core/common/global-refs";
import { Subject } from "rxjs";

@Component({
  selector: "cp-app",
  template: `
    <ngx-spinner
      type="line-scale"
      size="medium"
      color="#7CAF41"
      bdColor="rgba(255,255,255,0.8)"
    ></ngx-spinner>
    <router-outlet></router-outlet>
  `,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly loaderService: LoaderService,
    private readonly iconService: IconService,
    private readonly windowRef: WindowRef,
  ) {}
  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    if (this.windowRef.nativeWindow.pendo) {
      this.windowRef.nativeWindow.pendo.initialize();
    }
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loaderService.pushRequest();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loaderService.removeRequest();
      }
    });

    this.iconService.registerIcons();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
